import CheckIcon from '@mui/icons-material/Check';
import { Button, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { HotkeyDisplay } from '../../../core/hotkeys/HotkeyDisplay';

type FormActionsMuiSubmitButtonProps = {
  saveLabel?: string;
  saveIcon?: React.ReactNode;
  showTick: boolean;
  saveDisabled: boolean;
  isSubmitLoading: boolean;
  showSubmitHotkey: boolean;
  submitHotkey: string | null | undefined;
  submitDisabledTooltip?: React.ReactNode;
};

/** Primary submit button with optional success tick, hotkey hint, and disabled tooltip. */
export function FormActionsMuiSubmitButton({
  saveLabel,
  saveIcon,
  showTick,
  saveDisabled,
  isSubmitLoading,
  showSubmitHotkey,
  submitHotkey,
  submitDisabledTooltip,
}: FormActionsMuiSubmitButtonProps) {
  const submitEndIcon =
    showSubmitHotkey && submitHotkey ? (
      <HotkeyDisplay
        hotkey={submitHotkey}
        sx={{ ml: 0.5, fontSize: '0.8rem !important', opacity: 0.7 }}
      />
    ) : undefined;

  const submitLabel = showTick ? (
    <CheckIcon />
  ) : saveLabel ? (
    saveLabel
  ) : (
    <FormattedMessage id="common.form.saveBtnText" defaultMessage="Guardar" />
  );

  const submitButton = (
    <Button
      loading={isSubmitLoading}
      type="submit"
      variant="contained"
      color="primary"
      disabled={saveDisabled}
      startIcon={showTick ? undefined : saveIcon}
      endIcon={submitEndIcon}
      sx={{ minWidth: 130 }}
    >
      {submitLabel}
    </Button>
  );

  if (saveDisabled && submitDisabledTooltip) {
    return (
      <Tooltip title={submitDisabledTooltip}>
        <span>{submitButton}</span>
      </Tooltip>
    );
  }

  return submitButton;
}
